var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[(_vm.title)?_c('div',{staticClass:"section-title"},[_c('span',[_vm._v(_vm._s(_vm.title))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }